import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { ToastViewport } from './components/ui/Toast';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastViewport />
    </BrowserRouter>
  );
}
